controllers.controller('BitgoController', [
    '$scope', 'LocaleService', 'constants', 'UserService', 'ErrorService', 'ionicToast', 'Storage',
    function ($scope, LocaleService, Const, UserService, ErrorService, ionicToast, Storage) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.user = UserService.get();
        $scope.paymentMethods = Storage.get('paymentMethods') || [];
        $scope.constants = Const;
        $scope.displayCurrency = $scope.user.currency;

        $scope.cryptoWallet = {
            qrCode: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
            address: 'N/A',
            transactionId: 'N/A'
        };
        if ($scope.user.activeTradingAccount.cryptoWallet) {
            $scope.cryptoWallet = $scope.user.activeTradingAccount.cryptoWallet;
            if($scope.cryptoWallet.currency) {
                $scope.displayCurrency = $scope.cryptoWallet.currency;
            }
        }

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        $scope.copyToClipBoard = function () {
            var input = (document.getElementsByClassName('depositAddress'));
            HTMLCollection.prototype.isPrototypeOf(input) && input.length && (input = input[0]);

            if (input){
                input.select();
                input.setSelectionRange(0, $scope.cryptoWallet.address.length);
                document.execCommand('copy');
                input.blur();
                window.getSelection().removeAllRanges();

                ionicToast.show($scope.translation.copiedToCB, 'top', false, 5000, '');
            }
        }
    }
]);
